import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react"
import { getApiAccessToken } from "../auth/helpers"
import IShiftLog from "../types/operate/shift-logging/IShiftLog";
import IShiftLogFilterData from "../types/operate/shift-logging/IShiftLogFilterData";
import IShiftLogSubmission from "../types/operate/shift-logging/IShiftLogSubmission";
import IShiftLogUpdate from "../types/operate/shift-logging/IShiftLogUpdate";

export const shiftLoggingApi = createApi({
    reducerPath: 'shiftLoggingApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_PORTAL_API_URL}`,
        prepareHeaders: async (headers: Headers) => {
            const accessToken = await getApiAccessToken();
            if (accessToken) {
                headers.set("Authorization", `Bearer ${accessToken}`);
            }
        }
    }),
    tagTypes: ['ShiftLogging'],
    endpoints: (builder) => ({
        getShiftLogs: builder.query<IShiftLog[], IShiftLogFilterData>({
            query: (payload) => ({
                url: `/shiftlogging/GetLogs`,
                method: 'POST',
                body: payload
            }),
            providesTags: ["ShiftLogging"],
        }),
        AddShiftLog: builder.mutation<IShiftLog, IShiftLogSubmission>({
            query: (payload) => ({
                url: `/shiftlogging/AddLog`,
                method: 'POST',
                body: payload
            }),
            invalidatesTags: ["ShiftLogging"]
        }),
        UpdateShiftLog: builder.mutation<IShiftLog, IShiftLogUpdate>({
            query: (payload) => ({
                url: `/shiftlogging/UpdateLog`,
                method: 'POST',
                body: payload
            }),
            invalidatesTags: ["ShiftLogging"]
        }),
    })
});

export const {
    useGetShiftLogsQuery, useAddShiftLogMutation, useUpdateShiftLogMutation
} = shiftLoggingApi
